import React, { Fragment } from 'react'
import { AccessibilityIuppComponent } from 'loyal-react'
import Helmet from 'react-helmet'
import TitleAnnouncer from '../../App/Shell/TitleAnnouncer'

const AccessibilityIupp = (props) => {
  return (
    <Fragment>
      <Helmet>
        <title>{`Estatuto de acessibilidade - ${process.env.REACT_APP_TITLE || ''}`}</title>
      </Helmet>
      <TitleAnnouncer orientation='mobile' />
      <div className='container-fluid bg-color-ui-4'>
        <div>
          <div className='row'>
            <div className='col-12 px-0'>
              <div className=''>
                <AccessibilityIuppComponent />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  )
}

export default AccessibilityIupp



// WEBPACK FOOTER //
// ./src/features/Accessibility/AccessibilityIupp.js